import { ContractFeeChargeOne } from '@Common/types/bo/b2b/contract_fee_charges';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const contractFeeChargesPaidByChoices = makeChoicesCommon<ContractFeeChargeOne['paid_by']>()(
  {
    company: 'resources.bo_common.b2b.contract_fee_charges.paid_by_values.company',
    user: 'resources.bo_common.b2b.contract_fee_charges.paid_by_values.user',
  },
);

export const contractFeeChargesFeeLabelAffiliateChoices = makeChoicesCommon<
  ContractFeeChargeOne['fee_label'] & `affiliate_${string}`
>()({
  affiliate_account_closure:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_account_closure',
  affiliate_account_position_at_given_date:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_account_position_at_given_date',
  affiliate_collective_operation_by_cheque:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_collective_operation_by_cheque',
  affiliate_annual_custody_for_former_or_retired_employees:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_annual_custody_for_former_or_retired_employees',
  affiliate_annual_custody_for_former_or_retired_employees_pereco:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_annual_custody_for_former_or_retired_employees_pereco',
  affiliate_undelivered_mail_handling:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_undelivered_mail_handling',
  affiliate_direct_debit_rejection:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_direct_debit_rejection',
  affiliate_estate_settlement_high_amount:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_estate_settlement_high_amount',
  affiliate_estate_settlement_low_amount:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_estate_settlement_low_amount',
  affiliate_pledging_or_release_of_assets:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_pledging_or_release_of_assets',
  affiliate_reissue_bank_transfer:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_reissue_bank_transfer',
  affiliate_repayment_by_cheque:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_repayment_by_cheque',
  affiliate_specific_mail_requests_processing:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_specific_mail_requests_processing',
  affiliate_reissue_cheque:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_reissue_cheque',
  affiliate_repayment_of_savings:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_repayment_of_savings',
  affiliate_repayment_reimbursement_triggered:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_repayment_reimbursement_triggered',
  affiliate_retractation_following_pereco_payment:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_retractation_following_pereco_payment',
  affiliate_search_for_documents_or_transactions_after_10_years:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_search_for_documents_or_transactions_after_10_years',
  affiliate_search_for_documents_or_transactions_before_10_years:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_search_for_documents_or_transactions_before_10_years',
  affiliate_statements_and_certificates:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_statements_and_certificates',
  affiliate_transfer_from_pee_to_another_manager:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_transfer_from_pee_to_another_manager',
  affiliate_transfer_from_pereco_to_another_manager_pct:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_transfer_from_pereco_to_another_manager_pct',
  affiliate_voluntary_payment_by_cheque:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.affiliate_voluntary_payment_by_cheque',
});

export const contractFeeChargesFeeLabelCompanyChoices = makeChoicesCommon<
  ContractFeeChargeOne['fee_label'] & `company_${string}`
>()({
  company_calculating_individual_allocations_particip:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_calculating_individual_allocations_particip',
  company_calculating_individual_allocations_profit:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_calculating_individual_allocations_profit',
  company_ccb_annual_fee:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_ccb_annual_fee',
  company_ccb_fee_per_account:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_ccb_fee_per_account',
  company_collective_transfer_to_another_manager:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_collective_transfer_to_another_manager',
  company_fee_per_account:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_fee_per_account',
  company_file_opening:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_file_opening',
  company_integration_of_affiliates_choices_via_mail_particip:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_choices_via_mail_particip',
  company_integration_of_affiliates_choices_via_mail_profit:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_choices_via_mail_profit',
  company_integration_of_affiliates_choices_via_mail_value:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_choices_via_mail_value',
  company_integration_of_affiliates_consultation_data_particip:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_consultation_data_particip',
  company_integration_of_affiliates_consultation_data_profit:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_consultation_data_profit',
  company_integration_of_affiliates_consultation_data_value:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_consultation_data_value',
  company_integration_of_affiliates_data:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_integration_of_affiliates_data',
  company_other: 'resources.bo_common.b2b.contract_fee_charges.fee_label.company_other',
  company_pee_fee_per_account:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_pee_fee_per_account',
  company_pee_pereco_annual_fee:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_pee_pereco_annual_fee',
  company_pereco_fee_per_account:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_pereco_fee_per_account',
  company_publishing: 'resources.bo_common.b2b.contract_fee_charges.fee_label.company_publishing',
  company_rejection_of_direct_debit_or_bank_transfer:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_rejection_of_direct_debit_or_bank_transfer',
  company_soles_annual_fee_tc:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_soles_annual_fee_tc',
  company_soles_annual_reduced_fee_tc:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_soles_annual_reduced_fee_tc',
  company_soles_fee_tc_per_affilliate:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_soles_fee_tc_per_affilliate',
  company_soles_reduced_fee_tc_per_affilliate:
    'resources.bo_common.b2b.contract_fee_charges.fee_label.company_soles_reduced_fee_tc_per_affilliate',
});

export const contractFeeChargesFeeLabelChoices = [
  ...contractFeeChargesFeeLabelAffiliateChoices,
  ...contractFeeChargesFeeLabelCompanyChoices,
];
